var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloud1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 64,
    viewBox: "0 0 192 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.999 53.3354H181.334V64.0001H191.999V53.3354Z",
    fill: "#99DEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.999 42.6704H181.334V53.335H191.999V42.6704Z",
    fill: "#99DEF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.334 53.3354H170.669V64.0001H181.334V53.3354Z",
    fill: "#99DEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.334 42.6704H170.669V53.335H181.334V42.6704Z",
    fill: "#99DEF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.334 32.0063H170.669V42.671H181.334V32.0063Z",
    fill: "#EBF9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.669 53.3354H160.004V64.0001H170.669V53.3354Z",
    fill: "#99DEF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.669 42.6704H160.004V53.335H170.669V42.6704Z",
    fill: "#CEEDFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.669 32.0063H160.004V42.671H170.669V32.0063Z",
    fill: "#CEEDFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.669 21.3418H160.004V32.0064H170.669V21.3418Z",
    fill: "#EBF9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.004 53.3354H149.338V64.0001H160.004V53.3354Z",
    fill: "#99DEF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.004 42.6704H149.338V53.335H160.004V42.6704Z",
    fill: "#CEEDFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.004 32.0063H149.338V42.671H160.004V32.0063Z",
    fill: "#CEEDFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.004 21.3418H149.338V32.0064H160.004V21.3418Z",
    fill: "#EBF9FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.004 10.6748H149.338V21.3394H160.004V10.6748Z",
    fill: "#EBF9FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.339 53.3354H138.664V64.0001H149.339V53.3354Z",
    fill: "#99DEF5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.339 42.6704H138.664V53.335H149.339V42.6704Z",
    fill: "#CEEDFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M149.339 32.0063H138.664V42.671H149.339V32.0063Z",
    fill: "#CEEDFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.339 21.3418H138.664V32.0064H149.339V21.3418Z",
    fill: "#EBF9FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.339 10.6748H138.664V21.3394H149.339V10.6748Z",
    fill: "#EBF9FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.663 53.3354H127.998V64.0001H138.663V53.3354Z",
    fill: "#99DEF5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.663 42.6704H127.998V53.335H138.663V42.6704Z",
    fill: "#CEEDFB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M138.663 32.0063H127.998V42.671H138.663V32.0063Z",
    fill: "#CEEDFB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.663 21.3418H127.998V32.0064H138.663V21.3418Z",
    fill: "#EBF9FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 53.3354H117.331V64.0001H127.996V53.3354Z",
    fill: "#99DEF5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 42.6704H117.331V53.335H127.996V42.6704Z",
    fill: "#99DEF5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 32.0063H117.331V42.671H127.996V32.0063Z",
    fill: "#CEEDFB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 53.3354H106.665V64.0001H117.33V53.3354Z",
    fill: "#99DEF5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 42.6704H106.665V53.335H117.33V42.6704Z",
    fill: "#99DEF5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 32.0063H106.665V42.671H117.33V32.0063Z",
    fill: "#CEEDFB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 21.3418H106.665V32.0064H117.33V21.3418Z",
    fill: "#CEEDFB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 53.3354H96.0005V64.0001H106.666V53.3354Z",
    fill: "#99DEF5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 42.6704H96.0005V53.335H106.666V42.6704Z",
    fill: "#99DEF5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 32.0063H96.0005V42.671H106.666V32.0063Z",
    fill: "#CEEDFB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 21.3418H96.0005V32.0064H106.666V21.3418Z",
    fill: "#CEEDFB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 53.3354H85.3352V64.0001H96.0004V53.3354Z",
    fill: "#99DEF5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 42.6704H85.3352V53.335H96.0004V42.6704Z",
    fill: "#99DEF5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 32.0063H85.3352V42.671H96.0004V32.0063Z",
    fill: "#CEEDFB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 21.3418H85.3352V32.0064H96.0004V21.3418Z",
    fill: "#CEEDFB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3351 53.3354H74.6699V64.0001H85.3351V53.3354Z",
    fill: "#99DEF5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3351 42.6704H74.6699V53.335H85.3351V42.6704Z",
    fill: "#CEEDFB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3351 32.0063H74.6699V42.671H85.3351V32.0063Z",
    fill: "#CEEDFB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3351 21.3418H74.6699V32.0064H85.3351V21.3418Z",
    fill: "#CEEDFB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3351 10.6748H74.6699V21.3394H85.3351V10.6748Z",
    fill: "#EBF9FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 53.3354H64.0046V64.0001H74.6698V53.3354Z",
    fill: "#99DEF5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 42.6704H64.0046V53.335H74.6698V42.6704Z",
    fill: "#CEEDFB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 32.0063H64.0046V42.671H74.6698V32.0063Z",
    fill: "#CEEDFB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 21.3418H64.0046V32.0064H74.6698V21.3418Z",
    fill: "#CEEDFB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 10.6748H64.0046V21.3394H74.6698V10.6748Z",
    fill: "#EBF9FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 0H64.0046V10.6744H74.6698V0Z",
    fill: "#EBF9FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0045 53.3354H53.3394V64.0001H64.0045V53.3354Z",
    fill: "#99DEF5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0045 42.6704H53.3394V53.335H64.0045V42.6704Z",
    fill: "#99DEF5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0045 32.0063H53.3394V42.671H64.0045V32.0063Z",
    fill: "#CEEDFB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0045 21.3418H53.3394V32.0064H64.0045V21.3418Z",
    fill: "#CEEDFB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0045 10.6748H53.3394V21.3394H64.0045V10.6748Z",
    fill: "#EBF9FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0045 0H53.3394V10.6744H64.0045V0Z",
    fill: "#EBF9FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 53.3354H42.6743V64.0001H53.3395V53.3354Z",
    fill: "#99DEF5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 42.6704H42.6743V53.335H53.3395V42.6704Z",
    fill: "#99DEF5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 32.0063H42.6743V42.671H53.3395V32.0063Z",
    fill: "#CEEDFB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 21.3418H42.6743V32.0064H53.3395V21.3418Z",
    fill: "#EBF9FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 10.6748H42.6743V21.3394H53.3395V10.6748Z",
    fill: "#EBF9FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 0H42.6743V10.6744H53.3395V0Z",
    fill: "#EBF9FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6718 53.3354H31.9968V64.0001H42.6718V53.3354Z",
    fill: "#99DEF5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6718 42.6704H31.9968V53.335H42.6718V42.6704Z",
    fill: "#99DEF5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6718 32.0063H31.9968V42.671H42.6718V32.0063Z",
    fill: "#CEEDFB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6718 21.3418H31.9968V32.0064H42.6718V21.3418Z",
    fill: "#EBF9FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6718 10.6748H31.9968V21.3394H42.6718V10.6748Z",
    fill: "#EBF9FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M31.997 53.3354H21.3318V64.0001H31.997V53.3354Z",
    fill: "#99DEF5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.997 42.6704H21.3318V53.335H31.997V42.6704Z",
    fill: "#99DEF5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M31.997 32.0063H21.3318V42.671H31.997V32.0063Z",
    fill: "#CEEDFB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3319 53.3354H10.6667V64.0001H21.3319V53.3354Z",
    fill: "#99DEF5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3319 42.6704H10.6667V53.335H21.3319V42.6704Z",
    fill: "#99DEF5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3319 32.0063H10.6667V42.671H21.3319V32.0063Z",
    fill: "#99DEF5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 53.3354H0.00146484V64.0001H10.6666V53.3354Z",
    fill: "#99DEF5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 42.6704H0.00146484V53.335H10.6666V42.6704Z",
    fill: "#99DEF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud1);
export default __webpack_public_path__ + "static/media/icon-cloud-1.6bd3e0e82d180b2d549d06949ba835cf.svg";
export { ForwardRef as ReactComponent };